import { FormActions } from "../../components/common/FormActions";
import { BooleanTags } from "../../components/common/registerUtils";
import { API_WORKFLOWS } from "../../utils/apis";
import {
  createEditAction,
  createViewAction,
  formatDate,
  formatDateTime,
  getForm,
  getRegister,
} from "../../utils/helpers";
import { URL_WORKFLOWS } from "../../utils/urls";

const url = URL_WORKFLOWS;

// REGISTER
export const useWorkflows = () => {
  const tableColumns = () => [
    { id: "name", header: "Name", filter: {} },
    { id: "workflow_levels", header: "Levels", filter: {} },
    { id: "description", header: "Description", filter: {} },
    { id: "is_active", header: "Status", filter: {} },
    { id: "created_at", header: "Created At", filter: {} },
    { id: "created_by", header: "Created By", filter: {} },
    { id: "actions", header: "Actions" },
  ];
  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        is_active: <BooleanTags status={item?.is_active} />,
        created_at: formatDate(item?.created_at),
        created_by: item?.created_by?.first_name,
        actions: (
          <FormActions
            actions={[
              createEditAction(url, item?.id),
              createViewAction(url, item?.id),
            ]}
          />
        ),
      };
    }),
  ];
  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Workflows Details",
          fields: {
            name: item?.name,
            workflow_levels: item?.workflow_levels,
            description: item?.description,
            created_at: formatDateTime(item?.created_at),
          },
        },
      ],
    };
  };

  const formRoute = getForm(url);

  return { tableData, tableColumns, formRoute, viewData };
};

// Workflows
export const useWorkflowsForm = ({ id }) => {
  const isEdit = !!id;
  const sections: any = [
    {
      title: "Workflows Details",
      fields: [
        {
          field_name: "name",
          label: "Name",
          type: "text",
          props: { required: !isEdit },
        },
        {
          field_name: "workflow_levels",
          type: "number",
          props: { required: !isEdit },
        },
        {
          field_name: "description",
          type: "text",
          props: { required: false },
        },
      ],
    },
  ];

  const redirect = getRegister(url);

  function onSubmit(payload: any, id: string | number) {
    if (id) {
      return {
        id,
        api: `${API_WORKFLOWS}`,
        params: {
          ...payload,
        },
      };
    }

    //   CREATE
    return {
      api: `${API_WORKFLOWS}`,
      params: {
        ...payload,
      },
    };
  }

  return { sections, redirect, onSubmit };
};
